<template>
<div
  class="d-flex justify-content-between mb-2 mx-4 border border-gray-600 rounded bg-white"
  size="lg"
>
  <!-- Content Image & Title -->
  <div class="my-3">
    <!-- Content Preview Image -->
    <b-img
      class="preview-image ml-3"
      :src="content.imageURL || (content.image ? content.image.fileLocation : undefined)"
      :alt="content.title"
      rounded
    />
    <span class="py-2 pl-2" v-b-modal="`content-view-${content.id}`">
      {{ truncateContentTitle(content.title) }}
    </span>
  </div>
  <div class="d-flex my-2">

    <!-- Pin Button -->
    <b-button
      class="mr-4"
      style="border-radius: 5px; padding: 4px 14px 0px 15px;"
      size="sm"
      :variant="isPinned ? 'primary' : 'outline-primary'"
      @click="togglePinned(content)"
    >
      <font-awesome-icon icon="thumbtack" />
    </b-button>

    <!-- Bars Icon -->
    <span class="bars-handle mt-2">
      <font-awesome-icon
        class="draggable-icon mr-3 hamburger-icon"
        icon="bars"
      />
    </span>

    <!-- Content Preview Modal -->
    <b-modal :id="`content-view-${content.id}`" size="lg" title="Preview" hide-footer lazy>
      <h2 class="mb-4 mt-2">{{ content.title }}</h2>
      <rich-text-content class="mb-4" :value="content.description"/>
    </b-modal>
  </div>
</div>
</template>

<script>

export default {
  props: {
    content: {
      type: Object,
      required: true,
    },
    isPinned: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    truncateContentTitle(contentTitle) {
      if (contentTitle.length < 40) {
        return contentTitle;
      } else {
        return contentTitle.substring(0, 40).concat('...');
      }
    },
    togglePinned(content) {
      if (this.isPinned) {
        this.$emit('unpinContent', content);
      } else {
        this.$emit('pinContent', content);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .draggable-icon {
    font-size: 1.3rem;
  }
  .hamburger-icon:hover {
    cursor: move;
  }
  .preview-image {
    width: 25px;
    height: 25px;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/campaign-admin/ContentItem.vue